<template>
    <div class="p-0 flex-grow-1 text-dark-50 py-2 py-lg-2 mb-5">
        <div class="py-2">
            <span class="mr-2">
                <span class="svg-icon svg-icon-success">
                    <BookOpenSvg />
                </span>
            </span>
            <span class="text-dark-50">{{ presentation.author_credentials.writing_course_attended }}</span>
        </div>
    </div>
</template>

<script>
import BookOpenSvg from "@/svg/BookOpenSvg.vue";

export default {
    components: { BookOpenSvg },

    props: ["presentation"],
};
</script>
